/**
 * Reviews.io Facade Pattern
 * Lädt Reviews.io erst bei Scroll oder Interaktion
 * Performance-Gewinn: ~63ms Hauptthread-Blockierung
 */

(function () {
  'use strict';

  let reviewsLoaded = false;
  let reviewsLoading = false;

  // Alle Reviews.io Widgets auf der Seite
  const WIDGET_SELECTORS = [
    '#reviewsio-carousel-widget',
    '#reviewsio_nuggets',
    '.reviews-io-nuggets-widget',
    '.reviews-io-rating-bar-widget',
    '[data-reviewsio-widget]'
  ];

  /**
   * Lädt Reviews.io Scripts und CSS
   */
  function loadReviewsIO() {
    if (reviewsLoaded || reviewsLoading) return;
    reviewsLoading = true;

    // 1. Lade Carousel Widget Script (falls benötigt)
    const carouselWidget = document.querySelector('#reviewsio-carousel-widget');
    if (carouselWidget) {
      loadScript('https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2024011810', function () {
        initCarouselWidget();
      });

      // Lade Carousel CSS
      loadStylesheet('https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2024011810');
      loadStylesheet('https://assets.reviews.io/iconfont/reviewsio-icons/style.css?_t=2024011810');
    }

    // 2. Lade Nuggets Widget Script (falls benötigt)
    const nuggetsWidget = document.querySelector('.reviews-io-nuggets-widget');
    if (nuggetsWidget) {
      loadScript('//widget.reviews.io/modern-widgets/nuggets.js');
    }

    // 3. Lade Rating Bar Widget Script (falls benötigt)
    const ratingBarWidget = document.querySelector('.reviews-io-rating-bar-widget');
    if (ratingBarWidget) {
      loadScript('//widget.reviews.io/modern-widgets/rating-bar.js');
    }

    reviewsLoaded = true;
  }

  /**
   * Initialisiert das Carousel Widget
   */
  function initCarouselWidget() {
    const widget = document.querySelector('#reviewsio-carousel-widget');
    if (!widget || typeof carouselInlineWidget === 'undefined') return;

    // Widget-Konfiguration (aus reviewsio-carousel.liquid)
    new carouselInlineWidget('reviewsio-carousel-widget', {
      store: 'papasshorts.de',
      sku: '',
      lang: 'de',
      carousel_type: 'default',
      styles_carousel: 'CarouselWidget--sideHeader--withcards',
      options: {
        general: {
          review_type: 'company, product, third_party',
          min_reviews: '1',
          max_reviews: '20',
          address_format: 'CITY, COUNTRY',
          enable_auto_scroll: 10000,
        },
        header: {
          enable_overall_stars: true,
          rating_decimal_places: 2,
        },
        reviews: {
          enable_customer_name: false,
          enable_customer_location: true,
          enable_verified_badge: true,
          enable_subscriber_badge: true,
          enable_recommends_badge: true,
          enable_photos: true,
          enable_videos: true,
          enable_review_date: true,
          disable_same_customer: false,
          min_review_percent: 4,
          third_party_source: true,
          hide_empty_reviews: true,
          enable_product_name: true,
          tags: 'Widget',
          branch: '',
          enable_branch_name: false,
        },
        popups: {
          enable_review_popups: true,
          enable_helpful_buttons: true,
          enable_helpful_count: true,
          enable_share_buttons: true,
        },
      },
      translations: {
        verified_customer: 'Verifizierter Kunde',
      },
    });
  }

  /**
   * Lädt ein externes Script
   */
  function loadScript(src, callback) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (callback) {
      script.onload = callback;
    }
    document.head.appendChild(script);
  }

  /**
   * Lädt ein externes Stylesheet
   */
  function loadStylesheet(href) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  /**
   * Prüft ob ein Widget sichtbar ist
   */
  function isWidgetVisible() {
    for (let selector of WIDGET_SELECTORS) {
      const widget = document.querySelector(selector);
      if (widget) {
        const rect = widget.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Widget ist sichtbar oder fast sichtbar (500px Puffer)
        if (rect.top < windowHeight + 500) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Event Handler für Scroll
   */
  function onScroll() {
    if (isWidgetVisible()) {
      loadReviewsIO();
      cleanup();
    }
  }

  /**
   * Event Handler für Interaktion
   */
  function onInteraction() {
    loadReviewsIO();
    cleanup();
  }

  /**
   * Entfernt Event Listener nach dem Laden
   */
  function cleanup() {
    window.removeEventListener('scroll', onScroll, { passive: true });
    window.removeEventListener('touchstart', onInteraction, { passive: true });
    window.removeEventListener('mousemove', onInteraction, { passive: true });
    window.removeEventListener('click', onInteraction);
  }

  /**
   * Initialisierung
   */
  function init() {
    // Prüfe ob Widgets vorhanden sind
    let hasWidgets = false;
    for (let selector of WIDGET_SELECTORS) {
      if (document.querySelector(selector)) {
        hasWidgets = true;
        break;
      }
    }

    if (!hasWidgets) {
      return;
    }

    // Prüfe ob Widget bereits sichtbar ist
    if (isWidgetVisible()) {
      loadReviewsIO();
      return;
    }

    // Registriere Event Listener
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('touchstart', onInteraction, { passive: true });
    window.addEventListener('mousemove', onInteraction, { passive: true });
    window.addEventListener('click', onInteraction);

    // Fallback: Lade nach 5 Sekunden
    setTimeout(function () {
      if (!reviewsLoaded) {
        loadReviewsIO();
        cleanup();
      }
    }, 5000);
  }

  // Starte nach DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

